export default __webpack_public_path__ + "static/media/hand_with_phone.a02b6873.png";